<template>
  <!-- 企业个人实名认证 -->
  <div class="person-auth-root">
    <div class="box">
      <!-- 步骤条 -->
      <el-steps :active="step" finish-status="success" space="40%" align-center class="step-box">
        <el-step title="完善信息"></el-step>
        <el-step title="认证完成"></el-step>
      </el-steps>
      <div v-show="step == 0">
        <!-- 表单 -->
        <el-form ref="AuthFormRfe" :model="AuthForm" :rules="rules" label-width="100px">
          <el-form-item label="手机号码" prop="mobile">
            <el-input v-model="AuthForm.mobile"></el-input>
          </el-form-item>
          <el-form-item label="证件类型" prop="identityImg">
            <p style="text-align: left;">
              <span style="font-weight: bold;margin-right: 1vw;">身份证</span>
              <span>上传身份证照片，系统自动识别个人信息</span>
            </p>
            <div class="card-box">
              <!-- 人像面upload -->
              <div class="card-face">
                <el-upload
                  action="#"
                  :show-file-list="false"
                  :on-success="
                  (response, file, fileList) =>
                    handleIdeCareSuccess(
                      response,
                      file,
                      fileList,
                      'personalFront'
                    )
                "
                  :before-upload="
                  file => beforeIdeCareUpload(file, 'personalFront')
                "
                >
                  <!-- 展示已上传的图片 -->
                  <div class="preview-box" v-if="personalFront.url">
                    <img class="avatar" :src="personalFront.url" />
                    <div class="img-box">
                      <i
                        style="color:#fff"
                        class="el-icon-delete-solid delete-sty"
                        @click.stop="delBackImg('face')"
                      ></i>
                    </div>
                  </div>
                  <!-- 未上传时状态 -->
                  <div v-else>
                    <div class="card-item">
                      <i
                        class="el-icon-plus avatar-uploader-icon"
                        style="font-size:3vw;color:#C2C2C2"
                      ></i>
                      <p class="upload-tit">人像面</p>
                    </div>
                  </div>
                </el-upload>
              </div>
              <!-- 国徽面upload -->
              <div class="card-back">
                <el-upload
                  action="#"
                  :show-file-list="false"
                  :on-success="
                  (response, file, fileList) =>
                    handleIdeCareSuccess(
                      response,
                      file,
                      fileList,
                      'personalVerso'
                    )
                "
                  :before-upload="
                  file => beforeIdeCareUpload(file, 'personalVerso')
                "
                >
                  <!-- 已上传时状态 -->
                  <div class="preview-box" v-if="personalVerso.url">
                    <img class="avatar" :src="personalVerso.url" />
                    <div class="img-box">
                      <i
                        style="color:#fff"
                        class="el-icon-delete-solid delete-sty"
                        @click.stop="delBackImg('back')"
                      ></i>
                    </div>
                  </div>
                  <!-- 未上传时状态 -->
                  <div v-else class="card-item back">
                    <i
                      class="el-icon-plus avatar-uploader-icon"
                      style="font-size:3vw;color:#C2C2C2"
                    ></i>
                    <p class="upload-tit">国徽面</p>
                  </div>
                </el-upload>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="AuthForm.name"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="identityNo">
            <el-input v-model="AuthForm.identityNo"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-input v-model="AuthForm.code">
              <el-button
                slot="append"
                class="append-btn-sty"
                :disabled="codeText > 0"
                @click="getCode"
              >{{codeText > 0 ? codeText : '获取验证码'}}</el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: center;">
          <el-checkbox :checked="true" v-model="checked">
            <span style="color: #666666">我已阅读并同意</span>
            <a
              style="color: #409EFF"
              href="javascript:void(0)"
              @click="showProtocol = true"
            >《实名认证服务协议》</a>
          </el-checkbox>
        </div>
        <el-button type="primary" size="large" class="submit-btn-sty" @click="submit">提交</el-button>
      </div>
      <!-- 认证完成 -->
      <div class="stpe-end" v-show="step == 1">
        <!-- 成功 -->
        <div class="res-icon">
          <div>
            <img src="/images/auth/authIcon/suc.png" alt />
            <p class="text">实名认证成功</p>
            <el-button
              type="primary"
              @click="turnIndexPage"
            >返回首页{{ turnTime > 0 ? `（${turnTime}）`:'' }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 验证码弹窗 -->
    <!-- 发送验证码 窗口 -->
    <el-dialog title="提示" :visible.sync="codeVisi" width="30%" :before-close="codeCloseBefore">
      <el-form label-position="left">
        <el-form-item label="验证码：">
          <el-input v-model="imgCode" class="input-width" auto-complete="off" placeholder="输入验证码">
            <template slot="append">
              <span class="img-code" @click="getImgCode">
                <img :src="'data:image/png;base64,' + imgAuth.imgPath" />
              </span>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="codeCloseBefore">取 消</el-button>
        <el-button type="primary" @click="imgCodeConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 实名协议弹窗 -->
    <RealNameProtocol :visible.sync="showProtocol" type="register"></RealNameProtocol>
  </div>
</template>

<script>
import { name, mobile, identityNo } from "@/assets/js/lib/valid-methods";
// components
import RealNameProtocol from "../../components/protocol/RealName.vue";
// API
import { dingtalkApi } from "../../assets/js/http-serve/dingtalkApi";
import {
  postFileTempUpload,
} from "@/assets/js/http-serve/http-methods";

export default {
  components: { RealNameProtocol },
  data () {
    return {
      dingloginInfo:{},
      turnTime: 0,
      codeText: 0,
      codeVisi: false, // 发送验证码窗口
      // 身份证人像面
      personalFront: {
        url: "",
        targetId: ""
      },
      // 身份证国徽面
      personalVerso: {
        url: "",
        targetId: ""
      },
      AuthForm: {
        mobile: '',
        identityNo: '',
        name: '',
        code: ""
      },
      rules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: mobile, trigger: ["change", "blur"] }
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur", }],
        name: [{ required: true, message: "请输入姓名", target: "blur" }, { validator: name, trigger: "change" }],
        identityNo: [{ required: true, message: "请输入身份证号", target: "blur" }, { validator: identityNo, trigger: "change" }],
        identityImg: [{ validator: this.identityImgVail, trigger: "blur" }],
      },
      showProtocol: false, // 实名协议弹窗
      checked: true,
      step: 0, // 当前步骤
      imgCode: "",
      imgAuth: "",
    };
  },
  // data end
  methods: {
    /** 返回首页 */
    turnIndexPage () {
      // 跳转中间页进行账户中心登录，进入首页
      this.$router.replace({
        path: "/login/middle",
        query: { corpId: this.dingloginInfo.dingTalkCorpId }
      });
    },
    /** 提交 */
    submit () {
      if (!this.checked) return this.$message.error('请先阅读并同意《实名认证服务协议》')
      const _this = this;
      this.$refs.AuthFormRfe.validate(valid => {
        if (valid) {
          const loading = this.loadingStart(), { dingTalkUserId, dingTalkCorpId: corpId } = this.dingloginInfo;
          const params = {
            corpId,
            dingTalkUserId,
            ...this.AuthForm,
            personalFront: this.personalFront.targetId,
            personalVerso: this.personalVerso.targetId
          }
          dingtalkApi.perReplenishV2(params).then(res => {
            if (!res.success) return this.$message.error(res.description);
            if (res.data.identityAuth == 1) {
              _this.step = 1;
              _this.turnTime = 3
              const timer = setInterval(() => {
                _this.turnTime--
                if (_this.turnTime <= 0) {
                  clearInterval(timer)
                  _this.turnIndexPage()
                }
              }, 1000);
            }
          }).finally(() => {
            loading.close()
          })
        }
      });
    },
    /** 获取验证码 打开图形验证码窗口 */
    getCode () {
      this.$refs.AuthFormRfe.validateField("mobile", async error => {
        if (error) {
        } else {
          await this.getImgCode();
          this.codeVisi = true;
        }
      });
    },
    getImgCode () {
      const { dingTalkUserId, dingTalkCorpId: corpId } = this.dingloginInfo;
      let param = {
        corpId,
        dingTalkUserId
      };
      dingtalkApi.getImgCode(param).then(({ data }) => {
        this.imgAuth = data;
      });
    },
    // 发送短信验证码
    codeCloseBefore () {
      this.codeVisi = false;
    },
    // 发送短信验证码
    imgCodeConfirm () {
      const _this = this;
      const { dingTalkUserId, dingTalkCorpId: corpId } = this.dingloginInfo
      let param = {
        corpId,
        dingTalkUserId,
        mobile: _this.AuthForm.mobile,
        imageCode: _this.imgAuth.imgToken + "_" + _this.imgCode
      };
      dingtalkApi.codeSend(param).then(res => {
        if (!res.success) {
          return this.$message.error(res.description);
        }
        _this.codeCloseBefore();
        _this.codeText = 120;
        let timer = setInterval(() => {
          _this.codeText = --_this.codeText;
          if (_this.codeText === 0) {
            clearInterval(timer);
          }
        }, 1000);
      });
    },
    /** 删除图片 */
    delBackImg (type) {
      if (type === "face") {
        // 身份证人像面
        this.personalFront = {
          url: "",
          targetId: ""
        };
      } else {
        // 身份证国徽面
        this.personalVerso = {
          url: "",
          targetId: ""
        };
      }
    },
    /** 上传成功回调 */
    handleIdeCareSuccess (res, file, list, name) {
      this[name].url = URL.createObjectURL(file.raw);
    },
    /** 上传前校验及上传 */
    beforeIdeCareUpload (file, name) {
      const loading = this.loadingStart()
      const re = new RegExp("(.jpg|.png|.jpeg)$", "i");
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!re.test(file.name)) {
        this.$message.error("文件格式只能是jpg/png/jpeg的文件");
        return false;
      }
      if (!isLt20M) {
        this.$message.error("上传图片大小不能超过 20MB!");
        return false;
      }
      postFileTempUpload({ file: file, fileType: 1 })
        .then(data => {
          this[name].targetId = data.tempFile.targetId;
          if (name == "personalFront") {
            this.IDCardOCR({ file: data.tempFile.targetId, name });
          } else {
            loading.close()
          }
        })
        .catch(err => {
          loading.close()
          this.$message.warning(err.description || "上传文件失败");
        }).finally(() => { loading.close() });
    },
    /** 身份证OCR识别 */
    IDCardOCR (params) {
      const { file, name } = params, { dingTalkUserId, dingTalkCorpId: corpId } = this.dingloginInfo;
      // 身份证正面(人像面) name == "personalFront"
      const card = {
        corpId,
        dingTalkUserId,
        file,
        front: name == "personalFront" ? 1 : 0
      };
      dingtalkApi
        .ocrIdCard(card)
        .then(res => {
          if (res.success) {
            if (name == "personalFront") {
              this.AuthForm.name = res.data.idName;
              this.AuthForm.identityNo = res.data.idNo;
            }
          } else {
            if(respon.code == "10807") return this.$message.error('识别不成功（代码：23)');
            this.$message.error("识别失败，请重新拍摄图片并上传。");
          }
        })
    },
    /** 证件图片校验 */
    identityImgVail (rule, value, callback) {
      console.log(this.personalFront, this.personalVerso)
      const { targetId: face } = this.personalFront, { targetId: verso } = this.personalVerso;
      if (!face || !verso) {
        callback(new Error("请上传身份证人像面和国徽面图片"));
      } else {
        callback()
      }
    },
    loadingStart (info) {
      const loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
      return loading
    },
  },
  // methods end
  mounted () {
    this.dingloginInfo = JSON.parse(sessionStorage.getItem("dingloginInfo"));
  },
  computed: {}
};
</script>

<style scoped lang="less">
.person-auth-root {
  width: 100%;
  height: 85vh;
  padding: 10px;
  overflow: auto;
  background-color: #fff;
  // step3
  .box {
    width: 36vw;
    height: 100%;
    margin: 0 auto;
    padding: 1vw;
    text-align: center;
    .stpe-end {
      height: 45vh;
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      .res-icon {
        > div {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .text {
          font-size: 1.3vw;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #555555;
          margin-top: 20px;
        }
      }
    }
    .card-box {
      width: 20vw;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .card-face {
        display: flex;
        // align-items: center;
        // margin: 10px 0 20px 0;
      }
      .card-back {
        margin-left: 10px;
        display: flex;
        .back {
          background-image: url("/images/auth/authIcon/backAdd.png") !important;
        }
      }
      .preview-box {
        width: 180px;
        height: 115px;
        position: relative;
        &:hover .img-box {
          opacity: 1;
        }
        .card-img {
          margin-left: 0;
        }
        .img-box {
          opacity: 0;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.4);
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            font-size: 16px;
            cursor: pointer;
          }
        }
      }
      .card-item {
        width: 180px;
        height: 115px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-image: url("/images/auth/authIcon/faceAdd.png");
        background-size: cover;
        &.back {
          margin-left: 10px;
        }
      }
      .avatar {
        width: 180px;
        height: 115px;
      }
      .card-img {
        width: 180px;
        height: 115px;
        margin-left: 30px;
      }
    }
    .append-btn-sty {
      background-color: #ec1c1c;
      color: #fff;
    }
    .submit-btn-sty {
      width: 16vw;
      margin-top: 1vw;
    }
    .step-box {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 1vw;
    }
  }
}
/deep/ .el-step__head.is-process,
/deep/ .el-step__title.is-process,
/deep/ .el-step__head.is-success,
/deep/ .el-step__title.is-success {
  color: #ec1c1c;
  border-color: #ec1c1c;
}
.img-code {
  background-color: #fff;
  display: inline-block;
  margin: 0 -20px;
  width: 100px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;

  img {
    vertical-align: middle;
    display: inline-block;
    height: 38px;
    width: 100%;
  }
}
.input-width {
  width: 25vw !important;
}
</style>



// WEBPACK FOOTER //
// pages/dingtalkUse/personAuth.vue